// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"1a03ae58","732":"6fe17b4d","977":"6ff33907"}[chunkId] + ".chunk.js";
};